// src/components/list/DashboardDisplayFolders.tsx

import { ExpandMoreTwoTone } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Divider,
  Input,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material'
import { useState } from 'react'

import { FolderPool } from '@/types/domain/folder'

import { useFolderPool } from '../../hooks'
import { HStack } from '../HStack'

type DashboardDisplayFoldersProps = {
  disabled?: boolean
  onChange: (selected: number[]) => void
  selected: number[]
}

export const DashboardDisplayFolders = ({
  disabled,
  onChange,
  selected,
}: DashboardDisplayFoldersProps) => {
  const fPool: FolderPool = useFolderPool()

  const [filter, setFilter] = useState<string>('')

  const BULK_CHECKED = fPool.length === selected.length
  const label = `${selected.length}/${fPool.length}`

  const FILTER_FOLDER = f =>
    f.attributes.name.toLowerCase().includes(filter.toLowerCase())

  const onBulkToggle = event => {
    if (event.target.checked === false) onChange([])
    else onChange(fPool.map(f => Number(f.attributes.entity_id)))
    setFilter('')
  }

  const onChangeFilter = event => setFilter(event.target.value)

  return (
    <Accordion disabled={disabled}>
      <AccordionSummary expandIcon={<ExpandMoreTwoTone />}>
        <HStack sx={{ width: 1 }}>
          <Typography>Gebäude</Typography>

          <Chip label={label} />
        </HStack>
      </AccordionSummary>

      <Divider />

      <AccordionDetails sx={{ maxHeight: 300, overflow: 'auto', p: 0 }}>
        <ListSubheader sx={{ py: 0 }}>
          <HStack>
            <Input
              fullWidth
              onChange={onChangeFilter}
              placeholder={'Filter'}
              sx={{ py: 1 }}
              value={filter}
            />

            <Divider orientation={'vertical'} sx={{ height: 30 }} />
            <Tooltip title={'Massen Auswahl'}>
              <Switch checked={BULK_CHECKED} onClick={onBulkToggle} />
            </Tooltip>
          </HStack>
        </ListSubheader>

        <List>
          {fPool.filter(FILTER_FOLDER).map(f => {
            const { entity_id: fId, name } = f.attributes

            const checked = selected.includes(fId)

            const toggleSelected = () =>
              onChange(
                selected.includes(fId)
                  ? selected.filter(f => f !== fId)
                  : [...selected, fId]
              )

            return (
              <ListItem key={fId} sx={{ py: 0 }}>
                <ListItemButton onClick={toggleSelected} sx={{ px: 0 }}>
                  <ListItemText primary={name} sx={{ width: 0.5 }} />

                  <Switch checked={checked} />
                </ListItemButton>
              </ListItem>
            )
          })}
        </List>
      </AccordionDetails>
    </Accordion>
  )
}
